import { Component, OnInit, ViewChild, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import {SummaryInfoComponent} from '../summary-info/summary-info.component';
import {CreatingUsersComponent} from '../creating-users/creating-users.component';
import { CompanyService } from 'src/app/services/company.service';
import { Subject } from 'rxjs';
import { FreeTrialService } from '../free-trial.service';
import { AddClientCompanyComponent } from '../add-client-company/add-client-company.component';
import { InviteBeneAttorneyComponent } from '../invite-bene-attorney/invite-bene-attorney.component';

@Component({
  selector: 'app-create-client',
  templateUrl: './create-client.component.html',
  styleUrls: ['./create-client.component.scss']
})
export class CreateClientComponent implements OnInit {
  companyId;
  tabsList: any[];
  index = 0;
  activeTabIndex = 0;
  observableSubscription$ = new Subject();
  editingContent = false;
  @ViewChild(SummaryInfoComponent) summaryInfoComponent: SummaryInfoComponent;
  @ViewChild (CreatingUsersComponent) creatingUsersComponent: CreatingUsersComponent;
  @ViewChild (AddClientCompanyComponent) addClientCompanyComponent: AddClientCompanyComponent;
  @ViewChild(InviteBeneAttorneyComponent) inviteBeneAttorneyData: InviteBeneAttorneyComponent;

  currentState = '';
  toastr: any;
  plan: any;
  planLocalStorage: any;
  getCompanyName: any;
  countBene: any;
  countUser: any;
  getFreeTrailPlan: any;

  constructor( private activatedRoute: ActivatedRoute, private companyService: CompanyService, private freeTrialService: FreeTrialService
    ) { }

  ngOnInit() {
   this.activatedRoute.queryParams
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(params => {
        this.freeTrialService.getDetailsBasedLinkcode(params.linkRequestCode).subscribe((response:any) => {
          if (response){
            this.getCompanyName = response.companyLinkRequestObj.companyName;
            this.countBene = response.beneficiaryCount;
            this.countUser = response.userCount;
            localStorage.setItem('companyname', this.getCompanyName);
            localStorage.setItem('tokenFetch', response.bearerToken);
            this.plan = response.companyLinkRequestObj.ftMasterFreeTrialPlan.planName;
            localStorage.setItem('plan', this.plan);
            this.planLocalStorage = localStorage.getItem("plan");
            this.freeTrialService.setLinkRequestCode(params.linkRequestCode);
            this.freeTrialService.setbeneficiaryCount(this.countBene);
            this.freeTrialService.setuserCount(this.countUser);
            this.freeTrialService.setPlanFlow(this.plan);
            this.getFreeTrailPlan = this.freeTrialService.getFreeTrailPlan();
            if (this.getFreeTrailPlan == "Petitioner Plan") {
              this.tabsList = [
                { 'tabName':'1. Company Info','tabIconName':'Petition'},
                { 'tabName':'2. Creating Users','tabIconName':'Petition'},
                { 'tabName':'3. Invite Beneficiaries','tabIconName':'Petition'},
                { 'tabName':'4. Review Summary','tabIconName':'Petition'}
              ];
            }
            if (this.getFreeTrailPlan == "Attorney Plan") {
              this.tabsList = [
                { 'tabName':'1. Firm Info','tabIconName':'Petition'},
                { 'tabName':'2. Creating Users','tabIconName':'Petition'},
                { 'tabName':'3. Add Client Company','tabIconName':'Petition'},
                { 'tabName':'4. Invite Beneficiaries','tabIconName':'Petition'},
                { 'tabName':'5. Review Summary','tabIconName':'Petition'}
              ];
            }
          }
        });
      }
    );
  }

  handleChange(e) {
    this.activeTabIndex = e.index;
  }

getBaseLinkedCode() {
  this.activatedRoute.queryParams
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(params => {
        this.freeTrialService.getDetailsBasedLinkcode(params.linkRequestCode).subscribe((response:any) => {
          if (response){
            this.getCompanyName = response.companyLinkRequestObj.companyName;
            this.countBene = response.beneficiaryCount;
            this.countUser = response.userCount;
            localStorage.setItem('companyname', this.getCompanyName);
            localStorage.setItem('tokenFetch', response.bearerToken);
            this.plan = response.companyLinkRequestObj.ftMasterFreeTrialPlan.planName;
            localStorage.setItem('plan', this.plan);
            this.planLocalStorage = localStorage.getItem("plan");
            this.freeTrialService.setLinkRequestCode(params.linkRequestCode);
            this.freeTrialService.setbeneficiaryCount(this.countBene);
            this.freeTrialService.setuserCount(this.countUser);
            this.freeTrialService.setPlanFlow(this.plan);
            this.getFreeTrailPlan = this.freeTrialService.getFreeTrailPlan();
          }
        });
      }
    );
}

  parentListener(data: number){
    this.activeTabIndex = data;
    if (data == 0) {
        this.summaryInfoComponent.getReviewSummaryFirmInfo();
    }
    if(data == 2){
      this.summaryInfoComponent.getReviewSummaryDetails();
    }
    if (data == 3){
      this.inviteBeneAttorneyData.ngOnInit();
      this.summaryInfoComponent.getReviewSummaryFirmInfo();
    }
    if (data == 4){
      this.summaryInfoComponent.getClientCompanyFirmInfo();
    }
  }

  idListener(data:number){
    this.companyId = data;
  }
}
